/* eslint-disable eqeqeq *///忽略==的警告
import { IsEmergencyController, IsEmergencyDevice, IsEmergencyLight, isNoBulbDevice, IsSensorDevice } from "./pidUtils";
import { meshLog, SPGet } from "./spUtils";
import { bigEndianToLittleEndian } from "./dataUtils";

export const getNameBygroupID = (groupID) => {
    let name = '';
    const groupList = JSON.parse(SPGet("groupList"))
    for (let i = 0; i < groupList.length; i++) {
        if (groupList[i].groupID == groupID) {
            name = groupList[i].name;
        }
    }
    return name;
}


export const decimalToVersionString = (decimalNum) => {
    // 确保输入是16位无符号整数
    const vid = decimalNum & 0xFFFF;

    // 使用位运算提取版本段
    const major = (vid >>> 11) & 0x1F;  // 高5位
    const minor = (vid >>> 6) & 0x1F;   // 中间5位
    const build = vid & 0x3F;           // 低6位

    return `V${major}.${minor}.${build}`;
}

export const decimalToVersionString2 = (decimalNum) => {
    // 确保输入是16位无符号整数
    const vid = decimalNum & 0xFFFF;

    // 使用位运算提取版本段
    const major = (vid >>> 11) & 0x1F;  // 高5位
    const minor = (vid >>> 6) & 0x1F;   // 中间5位
    const build = vid & 0x3F;           // 低6位

    let versions = [major, minor, build]

    return versions;
}

export const getDeviceInfoByMac = (deviceMac) => {
    let deviceInfo = '';
    const nodes = JSON.parse(SPGet("nodes"))
    for (let i = 0; i < nodes.length; i++) {

        if (nodes[i].macAddress == bigEndianToLittleEndian(deviceMac)) {
            deviceInfo = nodes[i];
        }
    }
    return deviceInfo;
}

//DeviceManagePage界面类型选择
export const getTypeName = (type) => {
    if(type==0){
        return "Sensor";
    }else if(type==1){
        return "Emergency Driver";
    }else if(type==2){
        return "Emergency Lighting";
    }else if(type==3){
        return "Controller";
    }
    return "";
}

//DeviceManagePage界面类型选择
export const judgeDiffItemData = (pid,type) => {
    meshLog("-----------wjk type",type);
    if(type==0 && IsSensorDevice(pid)){
        // meshLog("wjk Sensor",type);
        return true;
    }else if(type==1 && IsEmergencyDevice(pid)){
        // meshLog("wjk Driver",type);
        return true;
    }else if(type==2 && IsEmergencyLight(pid)){
        // meshLog("wjk Light",type);
        return true;
    }else if(type==3 && IsEmergencyController(pid)){
        // meshLog("wjk Controller",type);
        return true;
    }
    return false;
}

